import firebaseApp from './firebaseConfig';

const fb_db = {
    _db: firebaseApp.database(),
    _storage: firebaseApp.storage(),

    pushDataTofirebaseApp(path, value) {
        return this._db.ref(path).push(value);// needs to be pushed instead of set / plus to set
    },

    setDataTofirebaseApp(path, value) {
        return this._db.ref(path).set(value);// needs to be pushed instead of set / plus to set
    },

    updateDataTofirebaseApp(path, value) {
        return this._db.ref(path).update(value);
    },

    getDataFromFB(path){
        return this._db.ref(path).once('value');
    },

    pullDataFromfirebaseApp(path, cb) {
        this._db.ref(path).once("value", (snapshot) => {
            if (typeof cb === "function")
                cb(snapshot.val())
        });
    },

    async checkIfDetailsExists(detaildVal) {
        let userRes = null;
        await this._db.ref("users").orderByChild("details").equalTo(detaildVal).once("value", snapshot => {
            if (snapshot.exists()) {
                const userData = snapshot.val();
                userRes = userData;
            } else {
                userRes = null;
            }
        });
        return userRes;
    },


    insertTheCurrentPlayerToChampions() {
        this.updateDataTofirebaseApp('champions/',
            {
                [localStorage.getItem('id')]: {
                    name: localStorage.getItem('name'),
                    score: Number(localStorage.getItem('score'))
                }
            });
    },


    async handleChampionsList() {
        let champions = await this._db.ref('champions').once('value');
        champions = champions.val();

        if (!champions || Object.keys(champions).length < 10) {
            this.insertTheCurrentPlayerToChampions();
        }
        else {
            champions = Object.entries(champions)
            champions = champions.sort((a, b) => b[1].score - a[1].score);
            let lowest_score = champions[champions.length-1];

            if (Number(lowest_score[1].score) < Number(localStorage.getItem('score'))) {
                this._db.ref('champions/' + lowest_score[0]).remove()
                this.insertTheCurrentPlayerToChampions();
            }
        }
    }

   

}

export default fb_db;
